import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as getters from './getters';
import auth from './modules/auth';
import company from './modules/company';
import cordova from './modules/cordova';
import device from './modules/device';
import geolocation from './modules/geolocation';
import passenger from './modules/passenger/passenger';
import driver from './modules/driver/driver';
import history from './modules/history';
import currentAccount from './modules/currentAccount';
import tempCache from './modules/temp-cache';
import messages from './modules/messages';

Vue.use(Vuex);

export default new Vuex.Store({
    actions,
    getters,
    state: {
        appVersion: 0
    },
    modules: {
        auth,
        company,
        cordova,
        device,
        geolocation,
        passenger,
        driver,
        history,
        tempCache,
        messages,
        currentAccount
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js